import * as Sentry from '@sentry/react';
import axios, { isAxiosError } from 'axios';

import { authKeys } from '@adflow/frontend/util-auth';
import {
	apiRequestInfoEventProcessor,
	sentryPleaseIgnoreThis,
	sharedSentryOptions,
} from '@adflow/shared/util-sentry';

import { queryClient } from './queryClient';

function isNotLoggedIn() {
	return queryClient.getQueryData(authKeys.session()) === null;
}

Sentry.init({
	...sharedSentryOptions,

	dsn: process.env.NX_PUBLIC_SENTRY_DSN_FRONTEND,

	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.captureConsoleIntegration({
			levels: ['error'],
		}),
		Sentry.extraErrorDataIntegration(),
		Sentry.replayIntegration({
			maskAllText: false,
			maskAllInputs: false,
			blockAllMedia: false,
		}),
	],

	// Capture no session replays...
	replaysSessionSampleRate: 0,
	// ...unless an error occurs
	replaysOnErrorSampleRate: 1,

	ignoreErrors: [
		"Can't perform a React state update on an unmounted component.",
		'status code 400',
		'status code 401',
		'401 (Unauthorized)',
		'status code 403',
		'403 (Forbidden)',
		'status code 404',
		'404 (Not Found)',
		'status code 409',
		'409 (Conflict)',
		'ResizeObserver loop limit exceeded',
		'LaunchDarkly',
		'Logged out',
		'The above error occurred in the',
		'no-response',
		'AbortError',
	],

	beforeSend: (event, hint) => {
		const error = hint.originalException;

		if (
			error?.[sentryPleaseIgnoreThis] ||
			isNotLoggedIn() ||
			(isAxiosError(error) &&
				(error.code === 'ERR_NETWORK' ||
					error.response?.status === 0 ||
					error.response?.status === 401 ||
					error.response?.status === 403 ||
					error.response?.status === 404 ||
					error.response?.status === 409)) ||
			(hint.mechanism?.type === 'onunhandledrejection' &&
				((error instanceof DOMException && error.name === 'AbortError') ||
					axios.isCancel(error)))
		) {
			return null;
		}

		try {
			event = apiRequestInfoEventProcessor(event, hint);
		} catch (err) {
			console.warn('Failed to attach API request info to Sentry event', err);
		}

		return event;
	},
});
